import {
  NOTE_PREVIEW_BODY_FONT_SIZE_PX,
  NOTE_PREVIEW_LABELS,
  NOTE_PREVIEW_SIGNATURE_HEIGHT_PX,
  NOTE_PREVIEW_TEXT_COLOR,
} from "../note-preview-constant";
import { NotePreviewAddendumInfo } from "../note-preview-types";
import ReportSectionTab from "./ReportSectionTab";
import { ReportSignatureDetail } from "./ReportSignatureBlock";

export interface ReportAddendumBlockProps {
  addendum: NotePreviewAddendumInfo;
}

/** The signed addendum below the original signature; the original note above it is unchanged. */
const ReportAddendumBlock = ({ addendum }: ReportAddendumBlockProps) => (
  <ReportSectionTab
    label={NOTE_PREVIEW_LABELS.addendum}
    style={{
      marginTop: 28,
      fontSize: NOTE_PREVIEW_BODY_FONT_SIZE_PX,
      color: NOTE_PREVIEW_TEXT_COLOR,
      breakInside: "avoid",
    }}
  >
    <div style={{ whiteSpace: "pre-wrap" }}>{addendum.text}</div>
    <div style={{ height: NOTE_PREVIEW_SIGNATURE_HEIGHT_PX, marginTop: 12 }}>
      {addendum.image && (
        <img
          src={addendum.image}
          alt={addendum.signerName}
          style={{ height: "100%", objectFit: "contain" }}
        />
      )}
    </div>
    <ReportSignatureDetail
      label={NOTE_PREVIEW_LABELS.name}
      value={addendum.signerName}
    />
    <ReportSignatureDetail
      label={NOTE_PREVIEW_LABELS.signedDateTime}
      value={addendum.signedAt}
    />
  </ReportSectionTab>
);

export default ReportAddendumBlock;
